import PrimaryLayout from './PrimaryLayout'
import OrderSearchLayout from './OrderSearchLayout'

export default PrimaryLayout

export {
    OrderSearchLayout
}